import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { isHTML } from '../../utils/common';
import styles from './References.styles';

const References = ({ references }) => {
  const isDangerouslySetInnerHTML = useMemo(() => isHTML(references), [references]);
  return (
    <div css={styles}>
      <div className="references-list">
        {references &&
          references.map((reference, index) => (
            <div className="references-list__link-wrapper" key={uuidv4()}>
              <sup className="references-list__link-number">{index + 1}</sup>&nbsp;
              {isDangerouslySetInnerHTML ? (
                <p className="references-list__link" dangerouslySetInnerHTML={{ __html: reference }} />
              ) : (
                <p className="references-list__link">{reference}</p>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};
export default References;
